import TheatreDashboard from './Components/TheatreView'

export default TheatreDashboard
